import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Vip = () => {
    const styles = {
        ar_vip_section: {
            padding: '50px 0',
            color: 'white',
            textAlign: 'center'
        },
        ar_vip_plan: {
            background: 'linear-gradient(180deg, #1a1a1a 0%, #000000 100%)',
            border: '1px solid #333',
            borderRadius: '10px',
            padding: '30px',
            transition: 'transform 0.3s',
            position: 'relative',
            overflow: 'hidden',
            marginBottom: '30px'
        },
        ar_vip_plan_featured: {
            border: '2px solid #ffd700',
            boxShadow: '0 0 30px rgba(255, 215, 0, 0.2)'
        },
        ar_vip_badge: {
            position: 'absolute',
            top: '20px',
            right: '-30px',
            background: '#ffd700',
            color: '#000',
            padding: '5px 30px',
            transform: 'rotate(45deg)',
            fontWeight: 'bold',
            fontSize: '12px'
        },
        ar_vip_title: {
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '10px',
            color: '#fff'
        },
        ar_vip_price: {
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#ffd700',
            margin: '20px 0'
        },
        ar_vip_price_span: {
            fontSize: '16px',
            color: '#888'
        },
        ar_vip_features: {
            listStyle: 'none',
            padding: '0',
            margin: '20px 0',
            textAlign: 'right',
            paddingRight: '20px'
        },
        ar_vip_features_li: {
            marginBottom: '10px',
            color: '#ccc'
        },
        ar_vip_features_li_i: {
            color: '#ffd700',
            marginLeft: '10px'
        },
        ar_vip_btn: {
            background: '#ffd700',
            color: '#000',
            border: 'none',
            padding: '10px 40px',
            borderRadius: '25px',
            fontWeight: 'bold',
            width: '100%',
            textTransform: 'uppercase'
        }
    };

    return (
        <div className="ar_mainBody">
            <section className="ar_main_content_area_wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ar_main_container_area">
                                <div className="ar_heading_area_top">
                                    <div className="ar_heading_title_back">
                                        <Link className="ar_back" to="/home"><img src="/assets/images/game-ui/reButton.png" alt="back" /></Link>
                                        <h3>אזור VIP</h3>
                                        <Link to="#"><img src="/assets/images/game-ui/question.png" alt="help" /></Link>
                                    </div>
                                    <div className="ar_heading_title_plus">
                                        <div className="arTitle_plus_area">
                                            <div className="arTitle_plus_img">
                                                <img src="/assets/images/game-ui/p1.png" alt="" />
                                                <p>198923</p>
                                            </div>
                                            <div className="arTitle_plus_img">
                                                <img src="/assets/images/game-ui/p2.png" alt="" />
                                                <p className="one152">152</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={styles.ar_vip_section}>
                <div className="container">
                    <div className="row justify-content-center">
                        
                        {/* Silver Plan */}
                        <div className="col-md-4">
                            <div style={styles.ar_vip_plan}>
                                <h4 style={styles.ar_vip_title}>חבר כסף</h4>
                                <div style={styles.ar_vip_price}>₪20 <span style={styles.ar_vip_price_span}>/חודש</span></div>
                                <ul style={styles.ar_vip_features}>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> +20% EXP בקרבות</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> גישה יומית לגלגל המזל</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> שם בצבע כסף בצ'אט</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> תיק מורחב (+50 מקומות)</li>
                                </ul>
                                <button style={styles.ar_vip_btn}>רכוש עכשיו</button>
                            </div>
                        </div>

                        {/* Gold Plan (Featured) */}
                        <div className="col-md-4">
                            <div style={{...styles.ar_vip_plan, ...styles.ar_vip_plan_featured}}>
                                <div style={styles.ar_vip_badge}>מומלץ</div>
                                <h4 style={styles.ar_vip_title}>חבר זהב</h4>
                                <div style={styles.ar_vip_price}>₪50 <span style={styles.ar_vip_price_span}>/חודש</span></div>
                                <ul style={styles.ar_vip_features}>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> +50% EXP בקרבות</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> גישה לאזור ה-VIP</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> שם בצבע זהב בצ'אט</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> מתנה יומית: 5 פוכדורים</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> ללא פרסומות</li>
                                </ul>
                                <button style={styles.ar_vip_btn}>רכוש עכשיו</button>
                            </div>
                        </div>

                        {/* Platinum Plan */}
                        <div className="col-md-4">
                            <div style={styles.ar_vip_plan}>
                                <h4 style={styles.ar_vip_title}>חבר פלטינה</h4>
                                <div style={styles.ar_vip_price}>₪100 <span style={styles.ar_vip_price_span}>/חודש</span></div>
                                <ul style={styles.ar_vip_features}>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> +100% EXP בקרבות</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> גישה מוקדמת לפוקימונים חדשים</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> שם נוצץ בצ'אט</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> פוקימון אגדי בכל חודש</li>
                                    <li style={styles.ar_vip_features_li}><i className="fa fa-check" style={styles.ar_vip_features_li_i}></i> תמיכה אישית 24/7</li>
                                </ul>
                                <button style={styles.ar_vip_btn}>רכוש עכשיו</button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default Vip;

